import { Lightning } from '@lightningjs/sdk';
import { getFontFaceFromStyle } from 'support/textUtils';
import TextLabel from '../TextLabel';

const DEFAULT_HEIGHT = 78;
const DEFAULT_WIDTH = 788;
const DEFAULT_FONT_SIZE = 28;
const DEFAULT_RADIUS = 8;
const LABEL_WIDTH = 624;
const PADDING_LEFT = 24;

export interface AbstractToastTemplateSpec
  extends Lightning.Component.TemplateSpec {
  labelText: string;
  image: Lightning.Element.PatchTemplate;

  Image: Lightning.textures.ImageTexture;
  Label: typeof TextLabel;
}

export default class AbstractToast
  extends Lightning.Component<AbstractToastTemplateSpec>
  implements
    Lightning.Component.ImplementTemplateSpec<AbstractToastTemplateSpec>
{
  private _image: Lightning.Element.PatchTemplate = {};
  private _labelText = '';
  protected _Image = (this as AbstractToast).getByRef('Image')!;
  protected _Label = (this as AbstractToast).getByRef('Label')!;

  get title() {
    return [this._Label.text?.text];
  }

  get label() {
    return this._Label.text?.text ?? '';
  }

  get labelText() {
    return this._labelText;
  }

  set labelText(labelText: string) {
    this._labelText = labelText;

    this._Label.patch({
      text: {
        text: this._labelText,
      },
    });
  }

  get image() {
    return this._image;
  }

  set image(image: Lightning.Element.PatchTemplate) {
    this._image = image;
    this._Image.patch(this._image);
  }

  override _setup() {
    this._image = {};

    this._Label.patch({
      text: {
        text: this._labelText,
      },
    });

    this._Image.patch(this._image);
  }

  static override _template(): Lightning.Component.Template<AbstractToastTemplateSpec> {
    return {
      h: DEFAULT_HEIGHT,
      w: DEFAULT_WIDTH,
      rect: true,
      shader: {
        type: Lightning.shaders.RoundedRectangle,
        radius: DEFAULT_RADIUS,
      },
      flex: {
        direction: 'row',
        alignItems: 'center',
        paddingLeft: PADDING_LEFT,
      },
      Image: {},
      Label: {
        type: TextLabel,
        w: LABEL_WIDTH,
        text: {
          fontSize: DEFAULT_FONT_SIZE,
          textAlign: 'left',
          fontFace: getFontFaceFromStyle('bold'),
          wordWrapWidth: LABEL_WIDTH,
        },
      },
    };
  }
}
